import(/* webpackMode: "eager", webpackExports: ["PcJobDetail"] */ "/codebuild/output/src2991130472/src/kenshoku-bank/nextjs/src/components/jobs/pc-job-detail.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SpJobDetail"] */ "/codebuild/output/src2991130472/src/kenshoku-bank/nextjs/src/components/jobs/sp-job-detail.tsx");
